import I from '../types.ts';

const sortEventCallback: I['sortEventCallback'] = async function () {
    await this.updateItems();
};

export default sortEventCallback;
